import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#121110] px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md border border-[#2A2825] bg-[#1A1917] p-10"
      >
        <img src="/images/logo-patch.png" alt="Bespoke Maestro" className="mb-6 h-24 w-auto rounded-sm" data-testid="admin-login-logo" />
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-[#C59B27]">Atelier Access</p>
        <h1 className="mt-3 font-serif text-3xl font-light text-[#FFFFFF]">Bespoke Maestro</h1>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="admin-login-form">
          <label className="block">
            <span className="mb-2 block font-mono text-[10px] uppercase tracking-[0.25em] text-[#858078]">Email</span>
            <input
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-[#2A2825] bg-[#121110] px-4 py-3 text-sm text-[#FFFFFF] outline-none transition-colors focus:border-[#C59B27]"
            />
          </label>
          <label className="block">
            <span className="mb-2 block font-mono text-[10px] uppercase tracking-[0.25em] text-[#858078]">Password</span>
            <input
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-[#2A2825] bg-[#121110] px-4 py-3 text-sm text-[#FFFFFF] outline-none transition-colors focus:border-[#C59B27]"
            />
          </label>

          {error && (
            <p data-testid="admin-login-error" className="border border-[#8B2626]/40 bg-[#8B2626]/10 px-4 py-3 text-sm text-[#E8A0A0]">
              {error}
            </p>
          )}

          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="w-full bg-[#C59B27] px-6 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-[#121110] transition-colors duration-200 hover:bg-[#FFFFFF] active:scale-95 disabled:opacity-50"
          >
            {loading ? "Entering…" : "Enter the Atelier"}
          </button>
        </form>

        <p className="mt-8 text-center">
          <Link to="/" data-testid="admin-login-back-link" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#858078] hover:text-[#FFFFFF]">
            ← Return to site
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
